import { mutatorAction } from 'satcheljs';
import { mailListItemAnimationStore } from '../store/Store';
import type { MailListItemAnimation } from '../store/schema/MailListItemAnimationStore';

export const removeActiveAnimationMutator: (animationToRemove: MailListItemAnimation) => void =
    mutatorAction('removeActiveAnimation', (animationToRemove: MailListItemAnimation): void => {
        mailListItemAnimationStore().activeAnimations =
            mailListItemAnimationStore().activeAnimations.filter(activeAnimation => {
                return activeAnimation.animationId !== animationToRemove.animationId;
            });
    });
